import request from "@/utils/request";

const carrierApi = {
  carrierList: (data) =>
    request.sendRequest({
      METHOD_NAME: "carriers.carrierList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  addOrModifyCarrier: (data) =>
    request.sendRequest({
      METHOD_NAME: "carriers.updateOrInsertById",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  carrierAllList: (data) =>
    request.sendRequest({
      METHOD_NAME: "carriers.carrierAllList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default carrierApi;
